import RequestHandler from "./request-handler";
class HeatingTableSummarizedService {
    constructor() {
        this.path = "HeatingTableSummarized";
        if (HeatingTableSummarizedService.instance) {
            return HeatingTableSummarizedService.instance;
        }
        HeatingTableSummarizedService.instance = this;
        return this;
    }
    async get() {
        return await RequestHandler.get(this.path);
    }
    async getColumns() {
        return await RequestHandler.get(this.path + '/columns');
    }
}
const instance = new HeatingTableSummarizedService();
export default instance;